<template>
  <NsiTable :pageTitle="pageTitle" :apiRoute="apiRoute" :cardName="cardName" :canEdit="canEdit" />
</template>

<script>
  import NsiTable from '../components/NsiTable.vue';

  export default {
    name: 'MassMediaCategory',
    components: {
      NsiTable,
    },
    data() {
      return {
        pageTitle: 'Анализ СМИ. Категории',
        canEdit: true,
        apiRoute: 'massMediaCategory',
        cardName: 'MassMediaCategoryCard',
      };
    },
    created() {},
    methods: {},
  };
</script>
